module.exports = __webpack_public_path__ + "static/media/pla_com_pla_sec.d9859069.png";